<template>
    <div id="action-edit">
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         src="@/assets/theme/light/status/01dailyActive/01back.svg">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('actionEdit.title') }}</div>
                    </van-col>
                    <van-col span="6">
                        <div class="save" @click="addAction">{{ $t('planEdit.save') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="train-name-box">
                <van-row>
                    <van-col span="12">
                        <div class="plan-name">{{ $t('actionEdit.actionName') }}</div>
                    </van-col>
                    <van-col span="12">
                        <div class="plan-name-input">
                            <van-field input-align="right" v-model="action.actionName"
                                       :placeholder="$t('actionEdit.actionNamePlaceholder')"/>
                        </div>
                    </van-col>
                </van-row>

                <van-row>
                    <van-col span="12">
                        <div class="plan-name">{{ $t('actionEdit.actionPart') }}</div>
                    </van-col>
                    <van-col span="12">
                        <div class="plan-name-input" @click="showPartPop = true">
                            <div class="vertically-center">
                                <span class="select-placeholder"
                                      v-if="!action.trainParts">{{ $t('actionEdit.selectPlaceholder') }}</span>
                                <span class="selected" v-else>{{ getPartText(action.trainParts) }}</span>
                                <img class="to-img" src="@/assets/theme/light/status/01dailyActive/06to.svg">
                            </div>
                        </div>
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="12">
                        <div class="plan-name">{{ $t('actionEdit.actionInstrument') }}</div>
                    </van-col>
                    <van-col span="12">
                        <div class="plan-name-input" @click="showInstrumentPop = true">
                            <div class="vertically-center">
                                <span class="select-placeholder"
                                      v-if="!action.instrumentType">{{ $t('actionEdit.selectPlaceholder') }}</span>
                                <span class="selected" v-else>{{ getInstrumentText(action.instrumentType) }}</span>
                                <img class="to-img" src="@/assets/theme/light/status/01dailyActive/06to.svg">
                            </div>
                        </div>
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="12">
                        <div class="plan-name">{{ $t('actionEdit.recordType') }}</div>
                    </van-col>
                    <van-col span="12">
                        <div class="plan-name-input" @click="showRecordPop = true">
                            <div class="vertically-center">
                                <span class="select-placeholder"
                                      v-if="!action.recordType">{{ $t('actionEdit.selectPlaceholder') }}</span>
                                <span class="selected" v-else>{{ getRecordText(action.recordType) }}</span>
                                <img class="to-img" src="@/assets/theme/light/status/01dailyActive/06to.svg">
                            </div>
                        </div>
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="12">
                        <div class="plan-name">{{ $t('actionEdit.actionBanner') }}</div>
                    </van-col>
                    <van-col span="12">
                        <div class="plan-name-input">
                            <van-uploader v-model="fileList" multiple :max-count="1"/>
                        </div>
                    </van-col>
                </van-row>
            </div>
            <div class="action-title">{{ $t('actionEdit.actionMuscles') }}</div>
            <div class="muscles-box">
                <div class="muscles-item" :class="{'active' : selectMuscles[index] == 1 }" v-for="(muscles, index) in muscles" @click="clickMuscles(index)">{{muscles}}</div>
            </div>
            <div class="action-title">{{ $t('actionEdit.actionPoint') }}</div>
            <div class="point-box">
                <div class="point-area">
                    <van-field
                        v-model="action.actionIntroduce"
                        rows="3"
                        autosize
                        type="textarea"
                        :placeholder="$t('actionEdit.pointPlaceholder')"
                    />
                </div>
            </div>
<!--            <div class="delete-box" v-if="action.actionId" @click="deleteAction">{{$t('actionEdit.delete')}}</div>-->
        </div>
        <van-popup v-model="showPartPop" round position="bottom">
            <van-picker
                :title="$t('actionEdit.actionPart')"
                show-toolbar
                :columns="partColumns"
                :default-index="partIndex"
                @cancel="showPartPop = false"
                @confirm="onConfirmPart"
            />
        </van-popup>
        <van-popup v-model="showInstrumentPop" round position="bottom">
            <van-picker
                :title="$t('actionEdit.actionInstrument')"
                show-toolbar
                :columns="instrumentColumns"
                :default-index="instrumentIndex"
                @cancel="showInstrumentPop = false"
                @confirm="onConfirmInstrument"
            />
        </van-popup>
        <van-popup v-model="showRecordPop" round position="bottom">
            <van-picker
                :title="$t('actionEdit.recordType')"
                show-toolbar
                :columns="recordColumns"
                :default-index="recordIndex"
                @cancel="showRecordPop = false"
                @confirm="onConfirmRecord"
            />
        </van-popup>
    </div>
</template>

<script>
import {WebJSBridge} from "../../utils/JSBridge1";
import {Dialog} from "vant";

export default {
    name: 'actionEdit',
    data() {
        return {
            showPartPop: false,
            partIndex: 0,
            partColumns: [this.$t('actionLibrary.action1'), this.$t('actionLibrary.action2'), this.$t('actionLibrary.action3'), this.$t('actionLibrary.action4'), this.$t('actionLibrary.action5'), this.$t('actionLibrary.action6'), this.$t('actionLibrary.action7')],
            showInstrumentPop: false,
            instrumentIndex: 0,
            instrumentColumns: [this.$t('actionLibrary.instrument1'), this.$t('actionLibrary.instrument2'), this.$t('actionLibrary.instrument3'), this.$t('actionLibrary.instrument4'), this.$t('actionLibrary.instrument5'), this.$t('actionLibrary.instrument6'), this.$t('actionLibrary.instrument7'), this.$t('actionLibrary.instrument8'), this.$t('actionLibrary.instrument9'), this.$t('actionLibrary.instrument10'), this.$t('actionLibrary.instrument11'), this.$t('actionLibrary.instrument12'), this.$t('actionLibrary.instrument13'), this.$t('actionLibrary.instrument14'), this.$t('actionLibrary.instrument15'), this.$t('actionLibrary.instrument16'), this.$t('actionLibrary.instrument17'), this.$t('actionLibrary.instrument18'), this.$t('actionLibrary.instrument19'), this.$t('actionLibrary.instrument20'), this.$t('actionLibrary.instrument21'), this.$t('actionLibrary.instrument22'), this.$t('actionLibrary.instrument23'), this.$t('actionLibrary.instrument24'), this.$t('actionLibrary.instrument25')],
            showRecordPop: false,
            recordIndex: 0,
            recordColumns: [this.$t('actionEdit.recordType1'), this.$t('actionEdit.recordType2'), this.$t('actionEdit.recordType3'), this.$t('actionEdit.recordType4')],
            fileList: [],
            muscles: [this.$t('actionLibrary.muscles1'), this.$t('actionLibrary.muscles2'), this.$t('actionLibrary.muscles3'), this.$t('actionLibrary.muscles4'), this.$t('actionLibrary.muscles5'), this.$t('actionLibrary.muscles6'), this.$t('actionLibrary.muscles7'), this.$t('actionLibrary.muscles8'), this.$t('actionLibrary.muscles9'), this.$t('actionLibrary.muscles10'), this.$t('actionLibrary.muscles11'), this.$t('actionLibrary.muscles12'), this.$t('actionLibrary.muscles13'), this.$t('actionLibrary.muscles14'), this.$t('actionLibrary.muscles15')],
            selectMuscles: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
            action: {
                actionId: '',
                actionName: '',
                trainParts: '',
                trainMuscles: '',
                instrumentType: '',
                actionIntroduce: '',
                recordType: '',
                bannerUrl: '',
                customize: 1,
            }
        }
    },
    watch: {
        $route(to, from) {
            // 在路由改变时重新加载数据
            this.dealActionDesc();
        }
    },
    mounted() {
        this.dealActionDesc();
    },
    methods: {
        back() {
            this.$router.back();
        },
        onConfirmPart(value, index) {
            this.action.trainParts = index + 1;
            this.showPartPop = false;
        },
        getPartText(index) {
            return this.$t('actionLibrary.action' + index);
        },
        onConfirmInstrument(value, index) {
            this.action.instrumentType = index + 1;
            this.showInstrumentPop = false;
        },
        getInstrumentText(index) {
            return this.$t('actionLibrary.instrument' + index);
        },
        onConfirmRecord(value, index) {
            this.action.recordType = index + 1;
            this.showRecordPop = false;
        },
        getRecordText(index) {
            return this.$t('actionEdit.recordType' + index);
        },
        clickMuscles(index) {
            if (this.selectMuscles[index] == 1) {
                this.$set(this.selectMuscles, index, 0);
            } else {
                this.$set(this.selectMuscles, index, 1);
            }
        },
        // 更新选中的十进制数字
        updateSelectedDecimal() {
            let trainMuscles = [];
            for (let i = 0; i < this.selectMuscles.length; i++) {
                if (this.selectMuscles[i] == 1) {
                    trainMuscles.push(i + 1);
                }
            }
            this.action.trainMuscles = trainMuscles.toString();
        },
        addAction() {
            this.updateSelectedDecimal();
            if (!this.action.actionName) {
                this.$toast(this.$t('actionEdit.actionNamePlaceholder'));
            } else if (!this.action.trainParts) {
                this.$toast(this.$t('actionEdit.actionPartPlaceholder'));
            } else if (!this.action.instrumentType) {
                this.$toast(this.$t('actionEdit.actionInstrumentPlaceholder'));
            } else if (!this.action.recordType) {
                this.$toast(this.$t('actionEdit.recordTypePlaceholder'));
            } else if (!this.action.bannerUrl && this.fileList.length == 0) {
                this.$toast(this.$t('actionEdit.actionBannerPlaceholder'));
            } else if (!this.action.trainMuscles) {
                this.$toast(this.$t('actionEdit.actionMusclesPlaceholder'))
            } else if (!this.action.actionIntroduce) {
                this.$toast(this.$t('actionEdit.actionPointPlaceholder'))
            } else {
                this.$api.trainPlan.addAction(this.action, this.fileList.length > 0 ? this.fileList[0].file: null).then(res => {
                    this.selectMuscles = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
                    this.action = {
                        actionId: '',
                        actionName: '',
                        trainParts: '',
                        trainMuscles: '',
                        instrumentType: '',
                        actionIntroduce: '',
                        recordType: '',
                        bannerUrl: '',
                        customize: 1
                    }
                    WebJSBridge.call("actionEditSuccess", {
                        updateTime: res.info.updateTime
                    }, function (res) {
                    });
                    this.$router.back();
                })
            }
        },
        dealActionDesc() {
            if (this.$route.query.actionDesc) {
                this.action = JSON.parse(this.$route.query.actionDesc);
                let muscles = this.action.trainMuscles;
                // 将 muscles 字符串转换为数组，并遍历每个元素
                let _this = this;
                muscles.split(',').forEach(muscle => {
                    // 将字符串转换为数字，并减去1以匹配数组索引
                    let index = parseInt(muscle) - 1;
                    // 将对应位置的数值设置为1
                    _this.$set(_this.selectMuscles, index, 1);
                    console.log(_this.selectMuscles);
                });
                if (this.action.bannerUrl) {
                    this.fileList = [{
                        url: this.action.bannerUrl
                    }]
                }
                this.partIndex = this.action.trainParts - 1;
                this.instrumentIndex = this.action.instrumentType - 1;
                this.recordIndex = this.action.recordType - 1;
            }
        },
        deleteAction() {
            Dialog.confirm({
                title: this.$t('actionEdit.deleteTitle'),
                message: this.$t('actionEdit.deleteDesc'),
                getContainer: "#action-edit",
                confirmButtonColor: 'var(--chart-color-1)',
                confirmButtonText: this.$t('actionEdit.confirm'),
                cancelButtonText: this.$t('actionEdit.cancel'),
                cancelButtonColor: 'rgb(133 130 130)',
            }).then(() => {
                this.$api.trainPlan.deleteAction({
                    actionId: this.action.actionId
                }).then(res => {
                    this.$router.go(-2);
                })
            }).catch(() => {
            });
        }
    }
}
</script>

<style scoped>
.save {
    font-size: 15px;
    color: var(--chart-color-1);
    text-align: right;
    margin: 13px 19px;
    line-height: 19px;
}

.green_light {
    color: #92D7B3;
}

.train-name-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 0px auto;
    padding: 8px 0;
}

.content {
    width: 100%;
    margin-top: 98px;
}

.plan-name {
    font-size: 15px;
    color: var(--text-color-2);
    line-height: 50px;
    margin-left: 18px;
}

/deep/ .van-cell {
    padding: 13px 0;
    background-color: var(--bg-color-2);
}

.plan-name-input {
    width: 150px;
    float: right;
    margin-right: 22px;
    text-align: right;
}

.action-title {
    font-size: 17px;
    color: var(--text-color-1);
    margin: 23px 0 16px 15px;
}

.add-icon {
    width: 26px;
    margin-right: 6px;
}

.add-action {
    text-align: center;
    font-size: 15px;
    color: var(--text-color-1);
    display: flex;
    align-items: center;
    justify-content: center;
}

.group-item {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto 12px;
}

.active-icon {
    width: 46px;
    height: 46px;
    margin-left: 18px;
}

.group-top {
    padding-top: 15px;
}

.flex-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.action-name {
    font-size: 17px;
    color: var(--text-color-1);
}

.action-capacity {
    font-size: 12px;
    color: var(--text-color-2);
    margin-right: 22px;
}

.action-num {
    font-size: 12px;
    color: var(--text-color-3);
}

.action-omit {
    color: var(--text-color-2);
    font-size: 24px;
    margin-right: 22px;
}

.add-top-line {
}

.select-placeholder {
    font-size: 15px;
    color: var(--text-color-3);
}

.vertically-center {
    display: flex;
    align-items: center;
    justify-content: right;
    height: 50px;
}

.selected {
    font-size: 15px;
    color: var(--text-color-1);
}

/deep/ .van-picker__toolbar {
    height: 57px;
}

/deep/ .van-picker__title {
    color: var(--text-color-1);
    font-size: 17px;
}

/deep/ .van-picker__confirm {
    color: var(--chart-color-1);
    font-size: 17px;
}

/deep/ .van-picker__cancel {
    font-size: 17px;
    color: var(--text-color-2);
}

.muscles-box {
    width: 345px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
}

.muscles-item {
    background-color: var(--bg-color-2);
    color: var(--text-color-2);
    border-radius: 15px 15px 15px 15px;
    padding: 8px 14px;
    font-size: 12px;
    margin-right: 4px;
    margin-bottom: 8px;
    width: 48px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.muscles-item.active {
    background-color: #DAEDE5;
    color: var(--chart-color-1);
}

.point-box {
    width: 345px;
    border-radius: 13px 13px 13px 13px;
    margin:  0 auto;
    background-color: var(--bg-color-2);
}

.point-area {
    width: 315px;
    margin: 0 auto 15px;
}

.delete-box {
    width: 345px;
    height: 56px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    color: #FF0101;
    font-size: 17px;
    margin-left: 15px;
    margin-bottom: 15px;
    text-align: center;
    line-height: 56px;
}

/deep/ .van-dialog__header {
    font-size: 19px;
    color: var(--text-color-1);
}

/deep/ .van-dialog__message {
    text-align: center;
}

/deep/ .van-picker {
    background-color: var(--bg-color-2);
    color: var(--text-color-1);
}

/deep/ .van-picker__mask {
    background-image: none;
}

/deep/ .van-picker-column__item {
    color: var(--text-color-1);
}

/deep/ .van-uploader__upload {
    background-color: var(--bg-color-1);
}
</style>


// WEBPACK FOOTER //
// src/views/trainPlan/04actionEdit.vue